import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { I18nService } from './i18n.service';
import { TranslationModeEnum } from '../enum/translation-mode-enum';
import { MetaConfig } from './meta-config';

@Injectable({
  providedIn: 'root',
})
export class UpdateMetaService {
  constructor(
    private meta: Meta,
    private title: Title,
    private i18nService: I18nService
  ) { }

  updateMetaTags(componentKey: string): void {
    const config = MetaConfig[componentKey];
    if (config) {
      const titleKey = this.i18nService.getText(
        config.title,
        TranslationModeEnum.PLACEHOLDER
      );
      const descriptionKey = this.i18nService.getText(
        config.description,
        TranslationModeEnum.PLACEHOLDER
      );
      const robotsKey = this.i18nService.getText(
        config.robots,
        TranslationModeEnum.PLACEHOLDER
      );

      if (titleKey !== '--') {
        this.title.setTitle(titleKey);
      }
      if (descriptionKey !== '--') {
        this.meta.updateTag({ name: 'description', content: descriptionKey });
      }
      if (robotsKey !== '--') {
        this.meta.updateTag({ name: 'robots', content: robotsKey });
      }
    } else {
    }
  }

  // updateBlogTags(post) {
  //   this.title.setTitle(METADATA[post]?.TITLE);
  //   this.meta.updateTag({
  //     name: 'description',
  //     content: METADATA[post]?.DESCRIPTION,
  //   });
  //   this.meta.updateTag({
  //     property: 'og:title',
  //     content: METADATA[post]?.TITLE,
  //   });
  //   this.meta.updateTag({
  //     property: 'og:description',
  //     content: METADATA[post]?.DESCRIPTION,
  //   });
  //   // this.meta.updateTag({ property: 'og:url', content: `https://ecapturedtech.com/blog/${post.url}` });
  //   this.meta.updateTag({
  //     property: 'og:image',
  //     content: METADATA[post]?.IMAGEN,
  //   });
  //   this.meta.updateTag({ property: 'og:type', content: 'article' });
  //   // this.meta.updateTag({ property: 'og:site_name', content: 'eyesCloud3D' });
  // }

  // removeBlogTags() {
  //   this.meta.removeTag("property='og:title'");
  //   this.meta.removeTag("property='og:description'");
  //   this.meta.removeTag("property='og:url'");
  //   this.meta.removeTag("property='og:image'");
  //   this.meta.removeTag("property='og:type'");
  //   this.meta.removeTag("property='og:site_name'");
  // }
}
